import {AccessorsMutatorsDecorator, Model} from '../../helpers';
import {Property} from './property.model';

/**
 * @class HouseAccount
 * @property {number} id
 * @property {string} name
 * @property {Property} property
 * @property {string} status
 * @property {string} created_at
 */
export class HouseAccount extends Model {

    static get STATUSES() {

        return {
            1: 'OPEN',
            0: 'CLOSED',
        };
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value = {}) {

        return value instanceof Property ? value : new Property(value);
    }

    formatStatus() {

        return HouseAccount.STATUSES[+this.status || 0];
    }
}

AccessorsMutatorsDecorator(
    'id',
    'name',
    'status',
    'is_private',
    'ntmp_account',
    'property_id',
    'property',
    'created_at',
    'created_at_tz',
    'created_by'
)(HouseAccount);



// WEBPACK FOOTER //
// ./src/pms-api/models/house-account.model.js